module.exports = __webpack_public_path__ + "static/media/orange.d0995989.svg";